import React, { createContext, ReactNode, useState } from 'react';

interface SidebarProviderProps {
  children: ReactNode;
}

export const SidebarContext = createContext(null);

export const SidebarProvider: React.FC<SidebarProviderProps> = ({
  children
}) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, toggleSidebar, closeSidebar }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
